<template>
    <v-card>
        <v-card-text v-for="forType in experimentRelationshipConfigForTypes">
            <v-row v-if="forType.relationshipConfigs.length > 0">
                <v-col class="text-left">
                    <h3>Experiment {{ getRelationshipDisplayForType(forType.type )}}:</h3>
                </v-col>
            </v-row>
            <v-row v-for="relationshipConfig of forType.relationshipConfigs">
                <experiment-relationship-setup-form-for-type
                    :experiment-relationship-config="relationshipConfig"
                    @onChanged="onChanged"
                />
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script setup lang="ts">
import {
    ExperimentRelationshipsForSetupDTO,
    RelationshipConfigForExperimentSetup,
    RelationshipConfigsForType,
} from "@/services/experimentRelationships/models";
import _ from "lodash";
import ExperimentRelationshipSetupFormForType
    from "@/components/ExperimentRelationshipConfigs/ExperimentRelationshipSetupFormForType.vue";

const { experimentRelationshipConfigForTypes } = defineProps<{
    experimentRelationshipConfigForTypes: RelationshipConfigsForType<RelationshipConfigForExperimentSetup>[];
}>();

const emit = defineEmits<{
    (e: "onChanged", experimentRelationshipForSetupDTOs: ExperimentRelationshipsForSetupDTO[]): void;
}>();

const selectedExperimentRelationshipsForSetup: ExperimentRelationshipsForSetupDTO[] = [];

function getRelationshipDisplayForType(type: string): string {
    return _.capitalize(type);
}

function onChanged(experimentRelationshipForSetupDTO: ExperimentRelationshipsForSetupDTO) {
    /**
     * If the experimentRelationship received from the relationship setup form has already been
     * captured in our selectedExperimentRelationshipsForSetup array, update that existing entry.
     *
     * Otherwise, just push the new experiment relationship selection(s) to the
     * selectedExperimentRelationshipsForSetup array.
     */
    const index = selectedExperimentRelationshipsForSetup.findIndex(
        (relationship) => {
            return relationship.registrySchemaId === experimentRelationshipForSetupDTO.registrySchemaId &&
                relationship.type === experimentRelationshipForSetupDTO.type;
        });
    if (index !== -1) {
        selectedExperimentRelationshipsForSetup[index] = experimentRelationshipForSetupDTO;
    } else {
        selectedExperimentRelationshipsForSetup.push(experimentRelationshipForSetupDTO);
    }

    emit("onChanged", selectedExperimentRelationshipsForSetup);
}
</script>
